// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import GlobalStyles from '../../../../../../../../config/styles';

const styles = theme => ({
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: 10,
    width: '100%',
    marginBottom: 50,
  },
  topContainer: {
    position: 'relative',
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    padding: '10px 30px',
    justifyContent: 'space-between',
    color: GlobalStyles.color.COLOR_PRIMARY,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    [theme.breakpoints.down(400)]: {
      padding: '10px 10px',
      fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
    },
  },
  orderTime: {
    marginLeft: 5,
  },
  processing: {
    backgroundColor: GlobalStyles.color.COLOR_REJECT,
  },
  paid: {
    backgroundColor: GlobalStyles.color.COLOR_GREEN,
  },
  default: {
    backgroundColor: GlobalStyles.color.COLOR_DEFAULT,
  },
  contentContainer: {
    width: '90%',
    margin: '20px 0',
    display: 'flex',
    flexDirection: 'column',
  },
  statusImage: {
    width: 25,
    height: 25,
  },
  line: {
    width: '100%',
    borderBottomWidth: 1,
    borderBottomColor: GlobalStyles.color.COLOR_GREY,
    borderBottomStyle: 'solid',
    marginTop: 15,
  },
  tableRowContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    color: GlobalStyles.color.COLOR_BLACK_GREY,
    fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
  },
  rowTitle: {
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    marginTop: 15,
  },
  rowDescription: {
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
  },
  borderBottom: {
    paddingBottom: 15,
    borderBottomWidth: 1,
    borderBottomColor: GlobalStyles.color.COLOR_GREY,
    borderBottomStyle: 'solid',
  },
});

export default styles;
